<template>
  <v-text-field
    v-model="input"
    :error-messages="error !== undefined ? error : []"
    :label="label != null ? label : i18n.t('WALLET.Amount') + ' (' + i18n.t('WALLET.Currency') + ')'"
    :maxlength="maxLength ? parseInt(maxLength) + Math.floor((parseInt(maxLength) - 1) / 3) : 13"
    :messages="priceString"
    autofocus
    class="centered-input"
    clearable
    outlined
    v-bind="$attrs"
    @input="handleInput"
    @keypress="isNumberKey"
  />
</template>

<script>
import Num2persian from 'num2persian';
import i18n from '../../plugins/EasyModal/i18n';

export default {
  name: 'priceInput',

  props: {
    value: [String, Number],
    error: [Object, Array],
    label: String,
    maxLength: Number,
    toChar: Boolean,
    max: [String, Number],
  },

  data() {
    return {
      input: this.value,
      i18n,
    };
  },

  created: function () {
    this.$emit('input', this.convertToRealPrice(this.value + ''));
  },

  mounted() {
    this.input = this.convertToHumanReadablePrice(this.value + '');
  },

  watch: {
      value(val) {
      if (this.max !== undefined && Number(val) > parseInt(this.max, 10)) {
        this.$emit('input', parseInt(this.max, 10));
        return;
      }

      var maxLen = this.maxLength != null ? this.maxLength : 10;
      if (val != null && val.toString().length > maxLen) {
        var fix = '';
        for (var i = 0; i < maxLen; i++) {
          fix += '9';
        }
        this.$emit('input', this.convertToRealPrice(fix));
        return;
      }

      this.input = this.convertToHumanReadablePrice(this.value);

      if (String(this.value).length > 10) {
        var fixPrice = this.convertToRealPrice(String(this.value).substring(0, 10));
        this.$emit('input', fixPrice);
        this.input = this.convertToHumanReadablePrice(fixPrice);
      }
    },
  },

  computed: {
    priceString: function () {
      return !!this.input
        ? (this.toChar ? Num2persian(this.value) : this.persianNum(this.currency(this.value))) +
            ' ' +
            this.i18n.t('WALLET.Currency')
        : '';
    },
  },

  methods: {
    convertToHumanReadablePrice(input) {
      return this.english(input?.toString())?.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },

    convertToRealPrice(input) {
      return parseInt(this.english(input ? input?.toString()?.replace(/,/g, '') : '0'));
    },

    handleInput(e) {
      let realPrice = this.convertToRealPrice(e);

      // اگر مقدار از max بیشتر شد، آن را روی max تنظیم کن
      if (this.max !== undefined && realPrice > parseInt(this.max)) {
        realPrice = parseInt(this.max);
        this.input = this.convertToHumanReadablePrice(realPrice);
      }

      this.$emit('input', realPrice);
    },

    isNumberKey: function (evt) {
      let persianChars = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        persianChars.indexOf(evt.key) === -1
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>
